import { useInfiniteQuery } from '@tanstack/react-query';
import { useThreadsApiClient } from '../api/useThreadsApiClient';
import { threadKeys } from './queryKeys';
import { toThreadPageView } from './toThreadView';

const DEFAULT_PAGE_SIZE = 6;

export function useAgentThreadsInfiniteQuery(
  agentId: string | null,
  pageSize: number = DEFAULT_PAGE_SIZE,
) {
  const client = useThreadsApiClient();

  return useInfiniteQuery({
    queryKey: threadKeys.agentList(agentId, pageSize),
    enabled: agentId !== null,
    initialPageParam: null as string | null,
    queryFn: async ({ pageParam, signal }) => {
      const raw = await client.fetchList(
        {
          limit: pageSize,
          cursor: pageParam ?? undefined,
          agentId: agentId ?? undefined,
          promptedOnly: true,
        },
        signal,
      );
      return toThreadPageView(raw, { limit: pageSize, offset: 0 });
    },
    getNextPageParam: (lastPage) => lastPage.nextCursor ?? undefined,
  });
}
